import { useRecoilState } from 'recoil'
import { FormDropDownList } from '../../../../../../GlobalComponents/awc-reactjs-components'
import {
    newFormIdAtom,
    newFormServiceTypeAtom,
    formTypeAtom
} from '../../../../../State/Atoms/FormProps/FormPropsAtoms'
import {
    assetTypesAtom,
    assetCategoriesAtom,
    newFormAssetTypeAtom,
    assetServiceTypesAtom,
    newFormCategoryAtom,
} from '../../../../../State/Atoms/AssetData/AssetDataAtoms'

export const FormDropdown = () => {
    const [newFormId, setNewFormId] = useRecoilState(newFormIdAtom)
    const [newFormServiceType] = useRecoilState(newFormServiceTypeAtom)
    const [formType] = useRecoilState(formTypeAtom)
    const [newFormAssetType] = useRecoilState(newFormAssetTypeAtom)
    const handleChooseNewForm = (event) => {
        setNewFormId(event.target.value)
    }
    return (
        newFormServiceType !== '' &&(
            <div>
                <h3>Choose Form</h3>
                <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <FormDropDownList
                        formType={formType}
                        assetType={newFormAssetType}
                        serviceType={newFormServiceType}
                        id='ddlChooseNewForm'
                        name='ddlChooseNewForm'
                        className='form-control form-control-sm'
                        key='ddlChooseNewForm'
                        onChange={handleChooseNewForm}
                    ></FormDropDownList>
                </div>
            </div>
        )
    )
}
